import React, { useContext, useEffect, useState } from "react";
import "./agent.css";
import { Accordion, AccordionSummary, Typography } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { Context } from "../../context/Context";
import Reservation from "../Reservation/Reservation";
import axios from "axios";
const Agent = ({ agent }) => {
  const { user, token } = useContext(Context);
  const [reservationsAgent, setReservationsAgent] = useState([]);
  useEffect(() => {
    const getReservations = async () => {
      const res = await axios.post(
        `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/agentlist`,
        { agent: agent.login, role: user.role },
        {
          headers: {
            authorization: "megaparkingIGHERQHIGQRE " + token,
          },
        }
      );
      console.log(res.data);
      setReservationsAgent(res.data);
    };
    getReservations();
  }, [user.role, agent.login, token]);

  const list = reservationsAgent.map((r) => (
    <Reservation reservation={r} key={r._id} />
  ));

  let countParking = reservationsAgent.filter((r) => r.hasArrived === true);
  countParking = countParking.filter((r) => r.isDone === false);

  return (
    <>
      <Accordion className="accordion">
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>
            <span
              style={{
                fontSize: "20px",
                marginRight: "20px",
                color: "black",
              }}
            >
              {agent.username} {agent.surname}
            </span>{" "}
            Parking: {countParking.length}.
          </Typography>
        </AccordionSummary>
        {list.length > 0 ? <div className="list">{list}</div> : null}
      </Accordion>
    </>
  );
};

export default Agent;
